angular
  .module 'filters'
  .filter 'cwCurrency', ($filter) ->
    (amount, symbol) ->
      if amount < 0
        val = $filter('currency')(amount * -1, symbol)
        "-#{val}"
      else
        $filter('currency')(amount, symbol)
